import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL;

const gettingLinkPreview = async (data) => {

  const userName = data
  const path = `/api/user/getLinkData/${userName}`
  const url = baseUrl + path
  const response = await axios.post(url)
  return response.data
}

const linkPreviewService = {
  gettingLinkPreview,
}

export default linkPreviewService
